import { render, staticRenderFns } from "./account-balance-query.vue?vue&type=template&id=4ecba181&scoped=true&lang=pug"
import script from "./account-balance-query.vue?vue&type=script&lang=js"
export * from "./account-balance-query.vue?vue&type=script&lang=js"
import style0 from "./account-balance-query.vue?vue&type=style&index=0&id=4ecba181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecba181",
  null
  
)

export default component.exports